import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../../shared/gql-client";
import { toast } from "sonner";
import i18next from "i18next";
import TireSetService from "../service/tireSetService";
import { TireSetMutateSliceModel } from "./tireSetMutateSliceModel";
import { GET_TIRESET } from "../queries/TiresetQueries";
import { CarTireSetResponseModel } from "../../domain/models/carTireSetModel";
import { UpdateTireSetPositionInputModel } from "../../domain/models/updateTireSetPositionInputModel";

const tireSetAPI = new TireSetService();

export const getTireset = createAsyncThunk(
  "tireSet/mutate/get",
  async (id: string, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    try {
      const response = await client.query("tiresets", GET_TIRESET, {
        id: parseInt(id),
      });

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return response.data[0] as CarTireSetResponseModel;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const deleteTireSet = createAsyncThunk(
  "tireSet/mutate/delete",
  async (id: number, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    tireSetAPI.setClient(client);
    try {
      return await tireSetAPI.delete(id);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updateTiresetPosition = createAsyncThunk(
  "tireSet/mutate/updatePosition",
  async (input: UpdateTireSetPositionInputModel, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    tireSetAPI.setClient(client);
    try {
      const response = await tireSetAPI.updateTiresetPosition(input);
      return response as CarTireSetResponseModel;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const initialState = {
  loading: false,
  tireset: undefined,
  error: undefined,
} as TireSetMutateSliceModel & { error?: string };

const tireSetMutateSlice = createSlice({
  name: "tireSetMutate",
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTireset.fulfilled, (state, action) => {
      state.loading = false;
      state.tireset = action.payload;
    });
    builder.addCase(deleteTireSet.fulfilled, () => {
      toast.error(i18next?.t("common:tireset.deleted"));
    });
    builder.addCase(updateTiresetPosition.pending, (state) => {
      state.loading = true;
      state.error = undefined;
    });
    builder.addCase(updateTiresetPosition.fulfilled, (state, action) => {
      state.loading = false;
      state.tireset = action.payload;
      toast.success(i18next?.t("common:tireset.location.updated"));
    });
    builder.addCase(updateTiresetPosition.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error?.message || "Update failed";
      toast.error(i18next?.t("common:tireset.location.update_failed"));
    });
  },
});

export const { clear, setLoading } = tireSetMutateSlice.actions;

export default tireSetMutateSlice.reducer;
